export const ActionTypes = {
    SET_LIQUIDATIONS_FILTERS: "SET_LIQUIDATIONS_FILTERS",
    REQUEST_GET_LIQUIDATIONS: 'REQUEST_GET_LIQUIDATIONS',
    ERROR_DATA_LIQUIDATIONS: 'ERROR_DATA_LIQUIDATIONS',
    CLEAR_JUST_LIQUIDATIONS: 'CLEAR_JUST_LIQUIDATIONS',
    CLEAR_LIQUIDATIONS: 'CLEAR_LIQUIDATIONS',
    CHANGE_STATION_LIQUIDATIONS: 'CHANGE_STATION_LIQUIDATIONS',
    GET_LIQUIDATIONS: 'GET_LIQUIDATIONS',
    REMOVE_LIQUIDATION: "REMOVE_LIQUIDATION",
    GET_CUSTOMERS_LIQUIDATIONS: 'GET_CUSTOMERS_LIQUIDATIONS',
    CLEAR_CUSTOMERS_LIQUIDATIONS: 'CLEAR_CUSTOMERS_LIQUIDATIONS',
    SET_ERROR_LIQUIDATIONS: 'SET_ERROR_LIQUIDATIONS',
    CLEAR_ERROR_LIQUIDATIONS: 'CLEAR_ERROR_LIQUIDATIONS',
    GET_PAYMENTS: 'GET_PAYMENTS',
    CREATE_LIQUIDATION_STATION_SALE: 'CREATE_LIQUIDATION_STATION_SALE',
    ADD_SGC_LIQUIDATION_SALE: 'ADD_SGC_LIQUIDATION_SALE',
    EDIT_LIQUIDATION_STATION_SALE: 'EDIT_LIQUIDATION_STATION_SALE',
    SET_CONFIG_PAGE_LIQUIDATION: 'SET_CONFIG_PAGE_LIQUIDATION',
    SET_CONFIG_PAGE_SIZE_LIQUIDATION: 'SET_CONFIG_PAGE_SIZE_LIQUIDATION',
    SET_CONFIG_FILTER_LIQUIDATION: 'SET_CONFIG_FILTER_LIQUIDATION',
    SET_CONFIG_SORTED_LIQUIDATION: 'SET_CONFIG_SORTED_LIQUIDATION',
    SET_SELL_STATION_LIQUIDATION: "SET_SELL_STATION_LIQUIDATION",
    SET_SGC_TO_LIQUIDATION: "SET_SGC_TO_LIQUIDATION",
    UPDATE_LIQUIDATION_DATE: "UPDATE_LIQUIDATION_DATE",
    REGENERATE_PDF: "REGENERATE_PDF",
    RESTORE_INITIAL: 'RESTORE_INITIAL',
    REGENERATE_TRANSFER_INVOICE_PDF: "REGENERATE_TRANSFER_INVOICE_PDF",
    RENEW_FILLING_ORDERS: "RENEW_FILLING_ORDERS",
    REPLACE_SETTLEMENT: "REPLACE_SETTLEMENT",
};
